function reveal() {
  var reveals = document.querySelectorAll(".scroll-efect-element");
  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 150;
    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("revealed");
    } else {
      reveals[i].classList.remove("revealed");
    }
  }
}
window.addEventListener("scroll", reveal);

// To check the scroll position on page load
reveal();

function GetReCaptchaID(containerID) {
  var retval = -1;
  $(".g-recaptcha").each(function(index) {
    if(this.id == containerID)
    {
      retval = index;
      return;
    }
  });

  return retval;
}

// function GetReCaptchaID(a) {
//   var s = -1;
//   return $(".g-recaptcha").each(function(e) {
//     this.id == a && (s = e)
//   }), s
// }

function sideFormScrollWidth() {
  var e = document.querySelectorAll(".side.show")[0],
    e = e.offsetWidth - e.clientWidth;
  document.querySelectorAll(".side.show .g-recaptcha")[0].style.marginRight = e + "px"
}


$(window).on("load", function() {
  let e = $("main .side").first();
  var a = e.attr("id");
  if (null != a) {
    let e = $("nav.navbar .contact-btn").first();
    e.attr("data-toggle", "side"), e.attr("data-target", "#" + a)
  }
  $("[data-toggle='side'][data-target]").click(function(e) {
    e.preventDefault();
    let a = $(this).data("target");
    var s;
    console.log("recaptcha load");
    reCaptchaLoad || (s = document.getElementsByTagName("head")[0], (e = document.createElement("script")).type = "text/javascript", e.src = "https://www.google.com/recaptcha/api.js", s.appendChild(e), reCaptchaLoad = !0), $("body").hasClass("modal-open") ? $(".side").hasClass("show") ? $(".side.show").not(a) ? ($(".side.show").removeClass("show"), a.addClass("show"), sideFormScrollWidth()) : ($(".side.show").removeClass("show"), $("body").removeClass("modal-open")) : $("body").removeClass("modal-open") : ($(a).addClass("show"), sideFormScrollWidth(), $("body").addClass("modal-open"))
  }), $(".side").click(function() {
    let e = $("body");
    $(this).hasClass("show") && $(this).removeClass("show"), e.hasClass("modal-open") && e.removeClass("modal-open")
  }), $(".side .side-dialog").click(function(e) {
    e.stopPropagation()
  }), $(".side .close").click(function() {
    let e = $(this).closest(".side"), a = $("body");
    e.hasClass("show") && e.removeClass("show"), a.hasClass("modal-open") && a.removeClass("modal-open")
  }), $(".side-frame .form-control").on("input", function() {
    var e = $(this).parent().find("label");
    "" != $(this).val() ? e.removeClass("label-hide") : e.addClass("label-hide")
  })
});


function isElementInViewport(element) {
  if($(element).length == 0) return false;
  var elementPosition = $(element).offset().top;
  var elementHeight = $(element).outerHeight();
  var scrollPosition = $(window).scrollTop();
  var scrollHeight = window.innerHeight;
  var scroll = scrollPosition + scrollHeight;
  if((elementPosition >= scrollPosition) && (elementPosition+1 <= scroll)) {
    return true;
  }
  else {
    false;
  }
}

function animateCounterUp(element, countedconst) {
  $(element).each(function() {
    var $this = $(this),
      countTo = $this.attr('data-count');
    $({
      countNum: $this.text()
    }).animate({
        countNum: countTo
      },
      {
        duration: 3000,
        easing: 'swing',
        step: function() {
          $this.text(Math.floor(this.countNum).toLocaleString());
        },
        complete: function() {
          $this.text(this.countNum.toLocaleString());
          //alert('finished');
        }
      });
  });
  if(countedconst == 1) counted = true;
  if(countedconst == 2)  counted2 = true;
}

var counted = false;
var counted2 = false;

var elementInViewport = isElementInViewport('.numbers');
var element2InViewport = isElementInViewport('.credit-component');

if(!counted) {
  // console.log('shit');
  if(elementInViewport) {

    // console.log('shit2');
    animateCounterUp('.numbers .date .number', 1);
  }
  else {
    $(window).scroll(function() {
      // console.log('shit3');
      elementInViewport = isElementInViewport('.numbers');
      if(!counted && elementInViewport) {
        animateCounterUp('.numbers .date .number', 1);

        // console.log('shit4');
      }
    })
  }
}
if(!counted2) {
  if(element2InViewport) {
    animateCounterUp('.credit-component .number .num', 2);
  }
  else {
    $(window).scroll(function() {
      element2InViewport = isElementInViewport('.credit-component');
      if(!counted2 && element2InViewport) {
        animateCounterUp('.credit-component .number .num', 2);
      }
    })
  }
}
